// Split a SQL blob on `;` boundaries that aren't inside a string literal or
// a comment. kinedb's parser rejects `;` entirely, so the console has to split
// client-side then run each statement as its own request.
//
// Comments (`-- …\n` and `/* … */`) are stripped from the output so a `;`
// inside one never starts a new statement and a comment-only chunk is dropped
// instead of surfacing as an empty "statement" in the result pane. Returns
// trimmed non-empty statements; an input without any `;` round-trips as a
// single-element array, so the caller can treat single- and multi-statement
// input the same.
export function splitSql(text) {
  const out = [];
  let buf = '', inStr = false, quote = '';
  for (let i = 0; i < text.length; i++) {
    const c = text[i];
    if (inStr) {
      buf += c;
      if (c === quote) {
        // doubled-quote inside a string is an escape, not a terminator
        if (text[i + 1] === quote) { buf += quote; i++; continue; }
        inStr = false; quote = '';
      }
      continue;
    }
    if (c === "'" || c === '"') { inStr = true; quote = c; buf += c; continue; }
    if (c === '-' && text[i + 1] === '-') {
      // line comment: skip to end of line (keep the newline as a separator)
      const nl = text.indexOf('\n', i);
      i = nl === -1 ? text.length : nl - 1;
      continue;
    }
    if (c === '/' && text[i + 1] === '*') {
      // block comment: skip past the closing */ (or to EOF if unterminated)
      const end = text.indexOf('*/', i + 2);
      i = end === -1 ? text.length : end + 1;
      buf += ' ';
      continue;
    }
    if (c === ';') {
      const t = buf.trim();
      if (t) out.push(t);
      buf = '';
      continue;
    }
    buf += c;
  }
  const last = buf.trim();
  if (last) out.push(last);
  return out;
}
